<template>
  <div class="custom-popup">
    <table>
      <tr>
        <td>tag</td>
        <td>{{ container.tag}}</td>
      </tr>

      <tr>
        <td>code</td>
        <td>{{ container.code}}</td>
      </tr>

      <tr>
        <td>lastupdate</td>
        <td>{{ container.lastupdate}}</td>
      </tr>

    </table>
  </div>
</template>

<script>
export default {
  name: 'ContainerPopup',
  props: {
    container: {
      type: Object,
      required: true
    }
  },
}
</script>

<style scoped>

</style>
